<template>
  <div class="full-page" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
      <div class="md-toolbar-row md-offset">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">{{ $route.name }}</h3>
        </div>
        <div class="md-toolbar-section-end">
          <md-button
            class="md-just-icon md-simple md-round md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

          <div
            class="md-collapse"
            :class="{ 'off-canvas-sidebar': responsive }"
          >
            <md-list>
              <md-list-item>
                <a @click="showRegisterAlert" style="cursor: pointer;">
                  <md-icon>person_add</md-icon>
                  Rejestracja
                </a>
              </md-list-item>
              <md-list-item v-if="!$store.getters['isAuthenticated']">
			          <router-link to="/login" @click="linkClick">
                  <md-icon>fingerprint</md-icon>
                  Logowanie
				        </router-link>
              </md-list-item>
              <md-list-item href="#vue" @click="$store.dispatch('logout')" v-if="$store.getters['isAuthenticated']">
                <md-icon>logout</md-icon>
                Wyloguj
              </md-list-item>
              
            </md-list>
          </div>
        </div>
      </div>
    </md-toolbar> -->
    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <notifications/>
      <div
        class="page-header header-filter"
        :class="setPageClass"
        filter-color="black"
        :style="setBgImage"
      >
        <div class="container md-offset">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <footer class="footer">
          <div class="container md-offset">
            <nav>
              <!-- <ul>
                <li>
                  <a href="https://posnet.pl" target="_blank">
                    Posnet
                  </a>
                </li>
                <li>
                  <a href="https://sekafi.pl" target="_blank">
                    Fiskas
                  </a>
                </li>
              </ul> -->
            </nav>
            <div class="copyright text-center">
              &copy; Posnet {{ new Date().getFullYear() }} - Wykonanie: <a href="https://sekafi.pl" target="_blank">Fiskas</a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";

export default {
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  inject: {
    autoClose: {
      default: true
    }
  },
  data() {
    return {
      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear()
    };
  },
  computed: {
    setBgImage() {
      // let images = {
      //   Pricing: process.env.VUE_APP_BASE_URL + "/img/bg-pricing.jpg",
      //   Login: process.env.VUE_APP_BASE_URL + "/img/login.jpg",
      //   'Email Not Verified': process.env.VUE_APP_BASE_URL + "/img/login.jpg",
      //   Register: process.env.VUE_APP_BASE_URL + "/img/register.jpg",
      //   'Aktywacja konta': process.env.VUE_APP_BASE_URL + "/img/register.jpg",
      //   Rejestracja: process.env.VUE_APP_BASE_URL + "/img/register.jpg",
      //   Lock: process.env.VUE_APP_BASE_URL + "/img/lock.jpg",
      //   'Reset hasła': process.env.VUE_APP_BASE_URL + "/img/lock.jpg"
      // };
      let colors = {
        Pricing: `#1f2933`,
        Login: `#1f2933`, // #3e5266 - wyjaśnienie #1f2933 with opacity 0.5 (w pliku _headers.scss) bo pomiędzy rgb 0,0,0 a 62,82,102 (#3e5266) jest rgb 31,41,51 (#1f2933)
        'Email Not Verified': `#1f2933`,
        Register: `#1f2933`,
        'Aktywacja konta': `#1f2933`,
        Rejestracja: `#1f2933`,
        Lock: `#1f2933`,
        'Reset hasła': `#F5F7FA`, // #F5F7FA with opacity 0.5
        'Password Forgot': `#F5F7FA`
      };
      return {
        // backgroundImage: `url(${images[this.$route.name]})`
        // backgroundColor: `#3e5266` // #1f2933 with opacity 0.5 (w pliku _headers.scss) bo pomiędzy rgb 0,0,0 a 62,82,102 (#3e5266) jest rgb 31,41,51 (#1f2933)
        backgroundColor: `${colors[this.$route.name]}`
      };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    }
  },
  methods: {
    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    showRegisterAlert() {
      Swal.fire({
        // title: "Rejestracja",
        text: 'W celu założenia konta na Portalu Klienta Posnet Polska S.A. skontaktuj się z Agentem Posnet.',
        // icon: "info",
        imageUrl: '/img/info_icon.png',
        imageHeight: 100,
        confirmButtonColor: '#4ea852',
        buttonsStyling: true,
        allowOutsideClick: false
      });
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  }
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
